/** Shared by the deletion notice, confirmation dialog and scheduled job. */
export const ACCOUNT_DELETION_GRACE_DAYS = 7
